// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lqx-","name":"styles_name__3n_N9","phone":"styles_phone__3_ZGe"};